import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function MUserCard({ img, name, email }) {

	return (
		<figure className="m-user-card">
			<img src={img} alt={name} />
			<figcaption>
				<p>
					<FormattedMessage id="ABOUT_US.MANAGER" defaultMessage="" />
					- {name}
				</p>
				<a href={`mailto:${email}`}>{email}</a>
			</figcaption>
		</figure>
	);
}

MUserCard.propTypes = {
	img: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.user-card.js